import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';

const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.instanceOf(Map).isRequired,
  dismissError: PropTypes.func.isRequired,
  isSimpleInput: PropTypes.bool,
  labelText: PropTypes.string,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string,
  additionalClassNames: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  isSimpleInput: false,
  labelText: 'LICENSE PLATE NUMBER: ',
  isRequired: false,
  placeholder: 'Your License Plate',
  additionalClassNames: [],
};

class LicensePlateField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  componentWillUnmount() {
    // clears the error if user leaves while in error state
    this.dismissError();
  }

  onChange(event) {
    this.dismissError();
    this.props.onChange(event.target.value);
  }

  dismissError() {
    this.props.dismissError({ error: 'licensePlate' });
  }

  getValidationError() {
    const { value } = this.props;

    if (isEmpty(value)) {
      return {
        licensePlate: {
          isValid: false,
          message: 'This field is required',
        },
      };
    } else if (value.length > 12) {
      return {
        licensePlate: {
          isValid: false,
          message: 'Must be 12 characters or less',
        },
      };
    }

    return false;
  }

  render() {
    const {
      errors,
      value,
      isSimpleInput,
      labelText,
      isRequired,
      placeholder,
      additionalClassNames,
    } = this.props;
    const isValid = errors.getIn(['licensePlate', 'isValid'], true);
    const errorMessage = errors.getIn(['licensePlate', 'message'], '');
    const labelClasses = cx({
      'required': true,
      'text-color-red': !isValid,
    });
    const fieldClasses = cx({
      'form-control': true,
      'form-control-error': !isValid,
      ...additionalClassNames,
    });
    const inputField = (
      <Fragment>
        <input
          type="text"
          id="plate_number"
          name="plate_number"
          value={value}
          onChange={this.onChange}
          className={fieldClasses}
          {...(isSimpleInput ? { autoComplete: 'off' } : { autoComplete: 'given-name' })}
          placeholder={placeholder}
        />
        {errorMessage ? (
          <div
            className={cx({
              'text-color-red': true,
              'margin-top-5': true,
              'margin-bottom-10': isSimpleInput,
            })}
          >
            {errorMessage}
          </div>
        ) : null}
      </Fragment>
    );

    if (isSimpleInput) {
      return inputField;
    }

    return (
      <div className="form-group">
        <label className={labelClasses} htmlFor="plate_number">
          {labelText}
          {isRequired ? <span className="required">*</span> : null}
        </label>
        <div className="form-field-container">
          {inputField}
        </div>
      </div>
    );
  }
}

LicensePlateField.propTypes = propTypes;
LicensePlateField.defaultProps = defaultProps;
export default LicensePlateField;
